import { useCallback } from 'react'

import { useSendSignInSmsMutation } from '@graphql/react-apollo'

// false on a payload error; a transport failure throws unless `bestEffort`,
// which silences the toast and answers false.
export function useSendSMSLoginCode() {
  // Browser-side on purpose: the backend rate-limits sends by connection IP.
  const [sendSignInSms] = useSendSignInSmsMutation()

  return useCallback(
    async (
      phone: string,
      { bestEffort = false }: { bestEffort?: boolean } = {},
    ) => {
      try {
        const { data } = await sendSignInSms({
          variables: { input: { phone: { code: 1, number: phone } } },
          ...(bestEffort ? { context: { errorToast: false } } : {}),
        })
        return !data?.sendSignInSms?.errors?.length
      } catch (error) {
        if (bestEffort) return false
        throw error
      }
    },
    [sendSignInSms],
  )
}
